export default __webpack_public_path__ + "static/media/placeholder-menuly-logo.e39e0edf.svg";